module.exports = __webpack_public_path__ + "media/svg/im-4fd71378.svg";